import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { useDispatch, useSelector } from "react-redux";
import { Logo, Time } from "../../assets/icons";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import ThemeToggleButton from "../../theme/ThemeToggleButton";
import { persianDaysArray, persianMonths } from "../../Utils/PersianDaysArray";
import { bannerURL, IMAGE_URL, urls } from "../../Utils/url";
import ClockComponent from "../ClockComponent";
import { Button } from "../Shared";

const HeaderMain = (props) => {
  const dispatch = useDispatch();
  const [image, setImage] = useState([]);
  const [info, setInfo] = useState();
  const isFaNum = useSelector((state) => state.persistedParams.isFaNum);
  const isOpenDrawer = useSelector((state) => state.persistedParams.isOpenDrawer);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    getBanner();
    // getInfo();
  }, []);

  // useEffect(() => {
  // 	const banner = setInterval(() => {
  // 		getBanner();
  // 	}, 30000);
  // 	return clearInterval(banner)
  // }, [])

  function changeIsFaNum(e) {
    dispatch({
      type: "IS_FA_NUM",
      payload: e,
    });
  }

  function closeDrawer() {
    dispatch({
      type: "IS_OPEN_DRAWER",
      payload: false,
    });
  }

  function getDay() {
    const day = moment().day();
    const month = moment().jMonth();
    const dayInMonth = moment().format("jDD");
    const year = moment().format("jYYYY");
    const dayName = persianDaysArray[day];
    const monthName = persianMonths[month];
    return `${dayInMonth} ${monthName}`;
  }

  function getDayName() {
    const day = moment().day();
    const dayName = persianDaysArray[day];
    return `${dayName}`;
  }
  function getBanner() {
    ApiCall(
      "GET",
      `${bannerURL}${urls.BANNERS}`,
      {},
      "getBanner-->",
      token,
      (res) => {
        // console.log('res', res);
        setImage(res.data || []);
      },
      (err) => {
        console.log("err", err);
      }
    );
  }

  // function getInfo() {
  // 	ApiCall(
  // 		"GET",
  // 		urls.getInfo,
  // 		{},
  // 		"getInfo-->",
  // 		token,
  // 		(res) => {
  // 			console.log('resInfo', res);
  // 			setInfo(res.data)
  // 		},
  // 		(err) => {
  // 			console.log('err', err);
  // 		}
  // 	)

  // }

  const logout = () => {
    dispatch({
      type: "IS_LOGIN",
      isLogin: true,
      token: null,
    });
  };

  return (
    <div>
      <header className="d-flex justify-content-around headerMain">
        <div className="_lang">
          <div className="d-flex flex-row align-items-center gap-2">
            <Button className={isFaNum ? "_fa_da" : "_fa"} onClick={() => changeIsFaNum(true)}>
              Fa
            </Button>
            <div className="_slash">/</div>
            <Button className={!isFaNum ? "_en_da" : "_en"} onClick={() => changeIsFaNum(false)}>
              En
            </Button>
          </div>
          <ThemeToggleButton />
        </div>
        <div
          className="d-flex flex-column text-center col-3 _secondCol "
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          {/* <p style={{ fontSize: '80%' }}>{info?.store_name || ''}</p> */}
          <div style={{ width: "45%" }}>
            <Logo style={{ width: "100%", height: "90%" }} />
          </div>
          {/* <div className='d-flex flex-row justify-content-center' style={{ alignContent: 'center', alignItems: 'end', marginTop: '-5%' }}>
						<p className='_paragraph'><PhoneCall className='_phoneIcon' />{info?.mobile}</p>
					</div> */}
        </div>

        <div className="d-flex flex-column col-6">
          <AliceCarousel autoPlay infinite={true} autoPlayInterval="5000">
            {image?.map((e) => (
              <img src={IMAGE_URL(e?.image)} className="_imageSlider" />
            ))}
          </AliceCarousel>
        </div>

        <div className="d-flex flex-column col-3 _firstCol">
          {/* <div className='d-flex flex-row justify-content-end' style={{ alignContent: 'center', alignItems: 'end', marginTop: '-5%' }}>
						<div onClick={logout} className="_btn" style={{ marginTop: '-1%', marginLeft: '1%' }} >
							<img src={Logout} className="_powerIcon" width={SCREEN_WIDTH * 0.02} />
						</div>
					</div> */}
          <div className="d-flex align-items-center">
            <time className="d-flex flex-column _time">
              <Time className="_icon" height="30px" width="30px" fontSize="small" />
              <div className="d-flex flex-column">
                <p className="d-flex mt-2">{getDayName()}</p>
                <p className="d-flex _date">{getDay()}</p>
              </div>
            </time>
            <ClockComponent />
          </div>
        </div>
      </header>
      {/* <Drawer
				direction="_right"
				isOpen={isOpenDrawer}
				closeDrawer={closeDrawer}
			>
				<MenuMain />
			</Drawer> */}
    </div>
  );
};

export default HeaderMain;
